import {
  APIMutationOptions,
  APIMutationResult,
  useAPIMutation,
} from 'shared/api/APIMutation';
import { APIQueryResult, useAPIQuery } from 'shared/api/APIQuery';
import { APIResponse, requestCarrierAPI } from 'shared/api/CarrierAPIClient';
import {
  SuperCardApplicationFormValues,
  SuperCardApplicationPrefillDTO,
  superCardApplicationPrefillSchema,
  SuperCardApplicationSubmitResponse,
  toSuperCardApplicationSubmitRequest,
} from './SuperCardApplicationDTO';
import { SuperCardDTO, superCardSchema } from './SuperCardDTO';

export function useSuperCard(): APIQueryResult<SuperCardDTO> {
  return useAPIQuery(
    ['super-card'],
    () =>
      requestCarrierAPI<APIResponse<SuperCardDTO>>(
        'GET /internal/web/supercard/',
      ),
    {
      schema: superCardSchema,
      refetchOnWindowFocus: false,
    },
  );
}

export function useSuperCardApplicationPrefill(): APIQueryResult<SuperCardApplicationPrefillDTO> {
  return useAPIQuery(
    ['super-card', 'application-prefill'],
    () =>
      requestCarrierAPI<APIResponse<SuperCardApplicationPrefillDTO>>(
        'GET /internal/web/supercard/application/prefill/',
      ),
    {
      schema: superCardApplicationPrefillSchema,
      refetchOnWindowFocus: false,
    },
  );
}

/**
 * Submits the native Basic Information form to the monolith and returns the
 * personal AtoB signup link.
 */
export function useSubmitSuperCardApplication(
  options?: APIMutationOptions<
    SuperCardApplicationFormValues,
    SuperCardApplicationSubmitResponse
  >,
): APIMutationResult<
  SuperCardApplicationFormValues,
  SuperCardApplicationSubmitResponse
> {
  return useAPIMutation<
    SuperCardApplicationFormValues,
    SuperCardApplicationSubmitResponse
  >(
    (values) =>
      requestCarrierAPI<APIResponse<SuperCardApplicationSubmitResponse>>(
        'POST /internal/web/supercard/application/',
        { json: toSuperCardApplicationSubmitRequest(values) },
      ),
    options,
  );
}
